export default __webpack_public_path__ + "static/arrow-going-up-e94982b1268962398ed1896a74f85b60.png";